import React from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import WebhookEventsTable from '../../components/super/webhooks/WebhookEventsTable';

// The global delivery log. The table itself is shared with the webhook detail
// page - here it simply runs unscoped.
function WebhookEventsList() {
    const navigate = useNavigate();

    return (
        <Grid container direction="row" spacing={2}>
            <Grid item xs={12}>
                <Box
                    mt={4}
                    mb={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h2">Webhook events</Typography>
                    <Button
                        variant="outlined"
                        onClick={() => navigate('/webhooks')}
                    >
                        Back to webhooks
                    </Button>
                </Box>

                <WebhookEventsTable rowsPerPage={25} />
            </Grid>
        </Grid>
    );
}

export default observer(WebhookEventsList);
